import React from "react";
import Particles from "react-particles-js";

import particleConfig from "./ParticleConfig";


export default function ParticleBackground() {
  return <Particles parmas={particleConfig}></Particles>;
}
